import React, { useState, useEffect, useContext } from "react";
import AuthService from "../services/AuthService";
import { AuthContext } from "../context/AuthContext";
import { useSnackbar } from "notistack";

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const Login = (props) => {
  const [user, setUser] = useState({ username: "", password: "" });
  const [message, setMessage] = useState(null);
  const authContext = useContext(AuthContext);

  const { enqueueSnackbar } = useSnackbar();

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    AuthService.login(user).then((data) => {
      const { isAuthenticated, user, message } = data;
      if (isAuthenticated) {
        setMessage(message);
        authContext.setUser(user);
        authContext.setIsAuthenticated(isAuthenticated);
        props.history.push("/account");
      } else {
        setMessage(message);
      }
    });
  };

  useEffect(() => {
    if (message !== null) {
      enqueueSnackbar(message.msgBody, {
        variant: message.msgError ? "error" : "info",
      });
    }
    setTimeout(() => {
      setMessage(null);
    }, 3000);
  }, [message]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <form onSubmit={onSubmit}>
        <h3>Login</h3>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TextField
            type="text"
            name="username"
            label="Username"
            onChange={onChange}
            className="form-control"
            placeholder="Username"
            style={{ margin: "5px 0px 20px 0px", backgroundColor: "#FAFAFA" }}
            required
          />
          <TextField
            type="password"
            name="password"
            label="Password"
            onChange={onChange}
            className="form-control"
            placeholder="Password"
            style={{ margin: "5px 0px", backgroundColor: "#FAFAFA" }}
            required
          />
          <Button
            type="submit"
            color="primary"
            variant="contained"
            style={{ margin: "40px 0px" }}
          >
            Login
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Login;
